import type { Reducer } from 'redux';

import type { FeedConfigSetAction } from '../../domains/feedConfig/actions.types';

import type { FeedConfig } from './types';

const initialState: FeedConfig = {
  threadCounts: {
    AttachableLink: 4,
    Bookmark: 4,
    Group: 4,
    Campaign: 4,
    GroupAgentSuggestions: 4,
    GroupTopQuestions: 4,
    GroupSimilarQuestions: 4,
    Home: 4,
    MoreForYou: 4,
    Inbox: 8,
    InboxDraft: 4,
    InboxScheduled: 4,
    LeaderEmployees: 4,
    LeaderHighlighted: 4,
    LiveEvent: 4,
    MyLeaders: 4,
    DiscoveryNetworkQuestion: 4,
    NetworkQuestion: 4,
    NetworkQuestionInbox: 4,
    NetworkTheme: 4,
    Promoted: 4,
    StorylineAll: 4,
    StorylineDiscovery: 4,
    StorylineFollowed: 4,
    TeamsMeeting: 4,
    Thread: 4,
    Topic: 4,
    TopicNetworkQuestion: 4,
    TopicUnified: 4,
    User: 4,
    UserWall: 4,
    UserGroups: 4,
    Search: 4,
    SingleNetworkQuestion: 4,
    M365CopilotSuggestion: 4,
  },
  loadOlderThreadCounts: {},
};

export type FeedConfigAction = FeedConfigSetAction;

const reducer: Reducer<FeedConfig, FeedConfigAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED_CONFIG.SET':
      return {
        ...state,
        threadCounts: {
          ...state.threadCounts,
          ...action.payload.feedConfig.threadCounts,
        },
        loadOlderThreadCounts: {
          ...state.loadOlderThreadCounts,
          ...action.payload.feedConfig.loadOlderThreadCounts,
        },
      };

    default:
      return state;
  }
};

export default reducer;
